import { forwardRef } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { useRichText } from './useRichText'
import classNames from 'classnames'
import { RichTextProps } from './types'

export const RichText = forwardRef<HTMLElement, RichTextProps>(
  ({ className, doc, options }, ref) => {
    const { renderOptions } = useRichText({ options })

    const updatedRenderOptions = {
      ...renderOptions,
    }

    // Paulo: as im moving the way to get the info to use the contenful package instead of the api I have to put bandages to check which one is being got
    const richInfo = doc?.content || doc
    if (!richInfo) return <></>
    doc.content = richInfo

    return (
      <span className={classNames('rich-text__container', className)} ref={ref}>
        {documentToReactComponents(doc, updatedRenderOptions)}
      </span>
    )
  },
)

RichText.displayName = 'RichText'
